import type { ComponentType } from 'react';
import Component from './DraggableProfileHero';
import Container from './DraggableProfileHero.container';
import type { Props } from './DraggableProfileHero';

const withConditionalRender = <P extends Props>(
  WrappedComponent: ComponentType<P>
): ComponentType<P> => {
  const ConditionalComponent = (props: P) => {
    if (!props.coverDeviation) {
      return null;
    }
    return <WrappedComponent {...props} />;
  };
  ConditionalComponent.displayName = `withConditionalRender(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return ConditionalComponent;
};

export default Container(withConditionalRender(Component));
